import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { IGX_CIRCULAR_PROGRESS_BAR_DIRECTIVES } from '@infragistics/igniteui-angular'

@Component({
    selector: 'app-sending',
    templateUrl: './sending.component.html',
    styleUrls: ['./sending.component.scss'],
    imports: [CommonModule, IGX_CIRCULAR_PROGRESS_BAR_DIRECTIVES]
})
export class SendingComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
